export default {
  width: 1920,
  height: 1080,
};
